import React, { useState, useRef, useEffect } from 'react';
import { FaUserCircle, FaSignOutAlt, FaShoppingCart } from 'react-icons/fa';
import './UserMenu.css';
import { useNavigate } from 'react-router-dom';
import { BiSolidPurchaseTag } from 'react-icons/bi';
import { LuHistory } from 'react-icons/lu';

const UserMenu = ({ userDetails, token, setShowModal, setIsPointHistory, setIsPurchase }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const toggleMenu = () => setOpen(!open);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogOut = () => {
    sessionStorage?.clear();
    navigate("/")
  }

  return (
    <div className="user-menu-container" ref={menuRef}>
      <FaUserCircle className="user-icon" onClick={toggleMenu} />
      {open && (
        <div className="dropdown-menu-user">
          <ul>

            {/* <li
              onClick={() => {
                setOpen(false);
                setIsPointHistory(true);
              }}
            ><LuHistory />Point History</li>
            <li
              onClick={() => {
                setOpen(false);
                setIsPurchase(true);
              }}
            ><FaShoppingCart />Purchase History</li>
            <li
              onClick={() => {
                setOpen(false);
                setShowModal(true);
              }}
            ><BiSolidPurchaseTag /> Purchase Plan</li> */}
            <li onClick={() => handleLogOut()}><FaSignOutAlt /> Log out</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
